module.exports = flarum.core.compat['components/AvatarEditor'];